import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class AllocationPreviousSplitLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.Display("Scheme")
    public incentiveSchemeName: string = "";

    @Attributes.Integer()
    public readonly currentFYFairValue: number = 0;

    @Attributes.Float()
    public currentFYSplit: number = 0;

    @Attributes.Integer()
    public readonly prior1FairValue: number = 0;

    @Attributes.Float()
    public prior1Split: number = 0;

    @Attributes.Integer()
    public readonly prior2FairValue: number = 0;

    @Attributes.Float()
    public prior2Split: number = 0;

    @Attributes.Integer()
    public readonly prior3FairValue: number = 0;

    @Attributes.Float()
    public prior3Split: number = 0;

    @Attributes.Integer()
    public readonly prior4FairValue: number = 0;

    @Attributes.Float()
    public prior4Split: number = 0;

    @Attributes.Integer()
    public readonly currentFYFaceValue: number = 0;

    @Attributes.Integer()
    public readonly prior1FaceValue: number = 0;

    @Attributes.Integer()
    public readonly prior2FaceValue: number = 0;

    @Attributes.Integer()
    public readonly prior3FaceValue: number = 0;

    @Attributes.Integer()
    public readonly prior4FaceValue: number = 0;

    // Client only properties / methods
}